<template>
  <v-card>
    <v-card-title>
      <div>
        <h3 class="headline">{{labels.excess}}</h3>
      </div>
      <v-spacer></v-spacer>
      <div>
        <!-- <v-menu offset-y v-if="hasAddableExcess" :max-height="350">
          <v-btn slot="activator">
            <span>Add Excess</span>
            <v-icon right>mdi-playlist-plus</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="excess in addableExcess" :key="excess.value" @click="addExcess(excess)">
              <v-list-tile-title>{{ excess.label }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> -->
        <v-autocomplete v-model="addExcess" v-if="hasAddableExcess" :items="addableExcess" label="Add Excess" item-text="label" item-value="value" prepend-icon="mdi-playlist-plus" outline @change="doAddExcess" clearable></v-autocomplete>
      </div>
    </v-card-title>
    <v-card-text>
      <!-- Instead of using hasExcess, we check local form value as we might have param and not any value in local form -->
      <v-container fluid grid-list-sm v-if="quoteParam.excessInit === 1 && excess.length > 0">
        <v-layout row wrap v-for="excess in excess" :key="excess.key" align-center>
          <v-flex xs4>
            <v-subheader>{{getParamExcess(excess.key).label}}*</v-subheader>
          </v-flex>
          <v-flex xs8 v-if="!getParamExcess(excess.key).addable" class="excessDiplay">
            {{$store.state.agency.quotation.commonInfo.currPrefix}}{{ formatDisplayNumber(excess.value) }}
          </v-flex>
          <template v-else>
            <v-flex xs7>
              <v-text-field class="mavPrefix" v-num-mask v-model="excess.value" :error-messages="errors.collect(excess.key)" :name="excess.key" :data-vv-name="excess.key" :data-vv-as="getParamExcess(excess.key).label" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:99999999.99'" :prefix="$store.state.agency.quotation.commonInfo.currPrefix"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-tooltip top>
                <v-btn flat icon color="red" slot="activator" @click="removeExcess(excess.key)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <span>Remove Excess</span>
              </v-tooltip>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-layout row wrap v-else-if="quoteParam.excessInit === 1 && excess.length <= 0">
        <v-flex xs12>
          No Excess found
        </v-flex>
      </v-layout>
      <loader v-else :card="false" :height="300" :init="doGetExcess" loadText="Loading Excess" errorText="Failed to load Excess" :loading="quoteParam.excessInit === 0"></loader>
    </v-card-text>
  </v-card>
</template>

<script>
import clone from 'clone'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        excess: 'Excess'
      },
      excess: [],
      addExcess: null
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    hasExcess() {
      // Excess is diff from stats in a way that we check form instead of param to decide if there is existing value
      if (this.excess && this.excess.length > 0) {
        return true
      } else {
        return false
      }
    },
    addableExcess() {
      let result = []
      result = this.quoteParam.excess.filter(excess => excess.addable)
      if (result && result.length > 0) {
        // Remove those that already exist in local form
        result = result.filter(excess => {
          for (let localExcess of this.excess) {
            if (localExcess.key === excess.value) {
              return false
            }
          }
          return true
        })
      }
      return result
    },
    hasAddableExcess() {
      if (this.addableExcess.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'excess': {
      handler: function (values) {
        this.$emit('input', values)
      },
      deep: true,
      immediate: true
    },
    'quoteParam.excessInit': function (value) {
      if (value === 1) {
        this.initExcess()
      }
    }
  },
  methods: {
    doInit() {
      if (this.quoteParam.excessInit !== 1) {
        this.doGetExcess()
      } else {
        this.initExcess()
      }
    },
    initExcess() {
      this.excess = []
      if (this.globalForm.excess && this.globalForm.excess.length > 0) {
        this.$set(this, 'excess', clone(this.globalForm.excess))
      }
    },
    doGetExcess() {
      this.$store.dispatch('motorQuoteExcess', { busCls: this.globalForm.busCls, cover: this.globalForm.cover })
    },
    getParamExcess(key) {
      for (let paramExcess of this.quoteParam.excess) {
        if (paramExcess.value === key) {
          return paramExcess
        }
      }
      return {}
    },
    removeExcess(excess) {
      this.excess.splice(this.excess.indexOf(this.excess.find(x => x.key === excess)), 1)
    },
    doAddExcess() {
      if (this.addExcess) {
        const excess = this.addableExcess.find(x => x.value === this.addExcess)
        if (excess) {
          this.excess.push({
            key: excess.value,
            value: excess.amount
          })
        }
        this.addExcess = null
      }
    },
    formatDisplayNumber(num) {
      return formatDisplayNumber(num)
    },
    doValidate() {
      this.resetMessages()
      return this.$validator.validateAll().then(result => {
        return result
      })
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
